import React, { useState } from "react"
import { Redirect } from "react-router-dom"
import IntegrationSetup from "../../components/IntegrationSetup/IntegrationSetup"
import "./IntegrationSetupPage.scss"
import { store } from "../../store"
import {
  NOTIFICATION_TYPES,
  ToastMessage,
} from "../../components/Notification/Notifications"
import { DELIVERY_API_INTEGRATE_ERROR } from "../../constants/notificationMsg"

const integrationsData = [
  {
    key: "location",
    settings: "apiIntegration",
    heading: "Location Information",
    explainText: "Allow digiD8 to access your location",
    toolTipText:
      "Let us know your location so we can find restaurants in range for you!",
  },
  {
    key: "delivery",
    settings: "apiIntegration",
    heading: "Connect to",
    explainText: "Allow digiD8 to access your delivery.com account",
    toolTipText: "Integrate with delivery.com for faster checkout experience",
  },
]

/* To be used when integrations tab is in place
 */
const IntegrationSetupPage = props => {
  const [apiConnect, setApiConnect] = useState(false)
  const guestToken = store.getState().auth.user.delivery_guest_token

  const apiSetter = key => {
    if (key === "delivery") {
      if (guestToken) {
        setApiConnect(true)
      } else {
        setApiConnect(false)
        ToastMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: DELIVERY_API_INTEGRATE_ERROR,
        })
      }
    } else {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition)
      }
      function showPosition(position) {
        props.setLocation(position)
      }
    }
  }

  if (apiConnect) {
    return <Redirect to="/dashboard" />
  }

  return (
    <div id="integrationSetupPage">
      <IntegrationSetup
        data={integrationsData}
        handleClick={apiSetter}
        changeText={props.changeText}
      />
    </div>
  )
}

export default IntegrationSetupPage
